import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckSquare, LogOut } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-40">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="navbar-logo">
          <div className="w-8 h-8 rounded-md bg-slate-900 text-white grid place-items-center">
            <CheckSquare size={16} />
          </div>
          <span className="font-semibold text-slate-900 text-lg tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>
            TaskFlow
          </span>
        </Link>
        <div className="flex items-center gap-3">
          {user && (
            <>
              <Link to="/todo" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-todo-link">
                My To-Do
              </Link>
              <Link to="/trash" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-trash-link">
                Trash
              </Link>
              <Link to="/profile" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-profile-link">
                Profile
              </Link>
              <Link to="/routes" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-routes-link">
                Routes
              </Link>
              <Link to="/assignees" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-assignees-link">
                Assignees
              </Link>
              {(user.role === "master_admin" || user.role === "sub_admin") && (
                <Link to="/admin/users" className="hidden sm:inline text-sm text-slate-600 hover:text-slate-900" data-testid="navbar-users-link">
                  Users
                </Link>
              )}
              <span className="hidden sm:block text-sm text-slate-600" data-testid="navbar-user-name">
                {user.name}
                {user.role && user.role !== "user" && (
                  <span className="ml-1.5 text-[10px] uppercase tracking-wider text-slate-400 font-semibold">
                    · {user.role.replace("_", " ")}
                  </span>
                )}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  logout();
                  navigate("/login");
                }}
                data-testid="navbar-logout-btn"
              >
                <LogOut size={14} className="mr-1.5" /> Logout
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
